// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atlassianAccessIcon{width:\"16px\";height:\"16px\"}", "",{"version":3,"sources":["webpack://./../../components/base/assets/css/atlassian-access-link.scss"],"names":[],"mappings":"AAAA,qBACE,YAAA,CACA,aAAA","sourcesContent":[".atlassianAccessIcon {\n  width: '16px';\n  height: '16px';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
